export const STYLE_SCHEMA = {
    BACKGROUND_COLOR: 'backgroundColor',
    OPACITY: 'opacity',
    CUSTOM_STYLE: 'custom',
}

